module.exports = __webpack_public_path__ + "1.0.1/img/logo.25e17873.png";